import _ from "lodash"
import React from 'react'
import { Link, Popover, PopoverProps } from '@amzn/awsui-components-react';
import { DynamicHook } from "../../backend/model"

const DYNAMIC_HOOK_REGEX = /\$(?<source>[a-z]+)\.(?<attribute>[a-z0-9.\-_]+)/
const DYNAMIC_HOOK_WIKI_LINK = "https://w.amazon.com/bin/view/NetworkTopologyModeling/AMOS/DNC/RuleGroupConfiguration/Selector#HDynamicHooks"

interface DynamicHookPopoverProps {
    value: string
}

export const DynamicHookPopover: React.FC<DynamicHookPopoverProps> = ({value}) => {
    const UNKNOWN_SOURCE_MESSAGE: PopoverProps = {
        header: "Dynamic Hook",
        content: <Link href={DYNAMIC_HOOK_WIKI_LINK}>Learn More</Link>
    }
    
    const DYNAMIC_HOOK_MESSAGES = new Map<string, (attribute: string) => PopoverProps>([
        ["program", (attribute) => ({
            header: "Rylai Program Dynamic Hook",
            content: <div>
                This returns a list of all FCs belonging to the <b>{attribute}</b> program in <u>any</u> region.
                <br />
                Programs are found on Scepter.
            </div>
        })],
    ])

    const getDynamicHook = (value: string): DynamicHook | undefined => {
        const matches = value.match(DYNAMIC_HOOK_REGEX)
        if (matches == null || matches.groups == null) return undefined
    
        const { source, attribute } = matches.groups
        
        return {
            source,
            attribute,
        }
    }
    
    const getDynamicHookMessage = (dynamicHook: DynamicHook) => {
        return DYNAMIC_HOOK_MESSAGES.get(dynamicHook.source)?.(dynamicHook.attribute) ?? UNKNOWN_SOURCE_MESSAGE
    }

    const dynamicHook = getDynamicHook(value)

    if (!dynamicHook) return <span>{value}</span> // failsafe in case dynamic hook is invalid

    return (
        <Popover {...getDynamicHookMessage(dynamicHook)}>
            {value}
        </Popover>
    );
}

export const isDynamicHook = (value: string): boolean => value.match(DYNAMIC_HOOK_REGEX) != null